import { z } from 'zod';
import { Option } from '../../types/Option';

const solarTechnologyValues = [
    'monocrystalline',
    'polycrystalline',
    'perc',
    'thin-film',
    'perovskite',
    'bifacial',
    'hit',
    'cigs',
    'cdte',
    'amorphous',
    'building-integrated photovoltaics',
] as const;

type SolarTechnology = (typeof solarTechnologyValues)[number];

const options: Option<SolarTechnology>[] = [
    { value: 'monocrystalline', label: 'Monocrystalline Silicon' },
    { value: 'polycrystalline', label: 'Polycrystalline Silicon' },
    { value: 'perc', label: 'Passivated Emitter and Rear Cell' },
    { value: 'thin-film', label: 'Thin-film' },
    { value: 'perovskite', label: 'Perovskite' },
    { value: 'bifacial', label: 'Bifacial' },
    { value: 'hit', label: 'Heterojunction with Intrinsic Thin-layer' },
    { value: 'cigs', label: 'Copper Indium Gallium Selenide' },
    { value: 'cdte', label: 'Cadmium Telluride' },
    { value: 'amorphous', label: 'Amorphous Silicon' },
    { value: 'building-integrated photovoltaics', label: 'Building-integrated Photovoltaics' },
];

export const SolarTechnologies = {
    validator: z.array(z.enum(solarTechnologyValues)),
    options,
};

export type SolarTechnologies = z.infer<typeof SolarTechnologies.validator>;
